module.exports = __webpack_public_path__ + "static/media/Otherimage.d6a16dfc.png";